<template>
  <div class="lpagination">
    <el-pagination
      background
      :current-page="query.page"
      :page-size="query.size"
      :page-sizes="pageSizes"
      :layout="layout"
      :total="query.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>

</template>

<script>
export default {
  name: 'Pagination',
  props: {
    query: {
      type: Object,
      default: () => {
        return {
          page: 1,
          size: 30,
          total: 0
        }
      }
    },
    pageSizes: {
      type: Array,
      default: () => [30, 50, 100, 200]
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    }
  },
  methods: {
    handleSizeChange (size) {
      this.query.size = size
      this.query.page = 1
      this.query.total = 0
      this.$emit('update:query', this.query)
      this.$emit('refresh')
    },
    handleCurrentChange (pageNum) {
      this.query.page = pageNum
      this.$emit('update:query', this.query)
      this.$emit('refresh')
    }
  }
}
</script>

<style lang="scss" scoped>

  .lpagination{
    display: flex;
    justify-content: flex-end;
    width:100%;
    padding:0px 20px 30px;
    box-sizing: border-box;
  }
  ::v-deep .el-pager li.number,
  .el-pagination ::v-deep button {
  // border: 1px solid #dcdfe6;
    border-radius: 4px;
    margin-left: 10px;
    color: #4e555b;
    background-color: #fff !important;
    //font-size: 400 !important;
    text-align: center;
  }
  ::v-deep .el-pager li.active,
  ::v-deep .el-pager li:hover,
  .el-pagination ::v-deep button:hover {
  // border: 1px solid #fff;
    border-radius: 4px;
   background-color: #fff !important;
    color:#5c90ff !important;
    // font-size: 400 !important;
  }
  .el-pagination ::v-deep .btn-prev,
  .el-pagination ::v-deep .btn-next {
    padding: 0;
  }
  ::v-deep .el-icon.more{
    background-color: #fff !important;
  }
</style>
